import { Box, Button, Input, LoadingOverlay } from "@mantine/core";
import { useRef, useState } from "react";
import { signUp } from "../../../services/users.js";
import { setUser } from "../../../store/modules/user.js";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setPage } from "../../../services/page.js";

const BussinesName = ({ setStep, wait }) => {
    const dispatch = useDispatch();
    const [businessName, setBusinessName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false); // State to manage loading indicator

    const saveUser = (userData) => {
        localStorage.setItem("user", JSON.stringify(userData));
        dispatch(setUser(userData));
    };

    const step2 = useRef(null);

    const handleCompleteName = async (e) => {
        try {
            e.preventDefault();
            setIsLoading(true); // Start loading

            const authResponse = await signUp({
                email,
                phone
            });
            await setPage({
                title: businessName,
                userId: authResponse._id
            })
            // const pageResponse 
            saveUser(authResponse);
            step2.current.classList.add("disappear");
            await wait(500);
            setStep(3);
            navigate("/home")
            // setIsLoading(false); // End loading
        } catch (error) {
            console.error(error);
            alert(error)
            setIsLoading(false)
        }
    };

    const handleInputChange = (e) => {

    };

    return (
        <Box ref={step2} className="reveal" position="relative">
            <LoadingOverlay visible={isLoading} />
            <h2>¿Cómo se llama tu negocio?</h2>
            <br />
            <form onSubmit={handleCompleteName}>
                <Input
                    placeholder="Escribe el nombre de tu negocio"
                    value={businessName}
                    onChange={(e) => setBusinessName(e.target.value)}
                    disabled={isLoading} // Disable input while loading
                    mb="sm"
                    required
                />
                <Input
                    placeholder="Número telefónico"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    disabled={isLoading} // Disable input while loading
                    mb="sm"
                />
                <Input
                    placeholder="Escribe tu correo electrónico"
                    value={email}
                    required
                    type="email"
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={isLoading} // Disable input while loading
                />
                <Box ta="right" mt="sm">
                    <Button type="submit" disabled={isLoading}>Listo</Button> {/* Disable button while loading */}
                </Box>
            </form>
        </Box>
    );
};

export default BussinesName;
